import axios from '@/plugins/axios'

export function postSuggestion(payload) {
	return axios({
		url: '/admin/setting/suggestion',
		method: 'POST',
		data: {
			...payload
		}
	})
}